<style lang="scss">
@media screen and (min-width: 55rem) {
  .more-button {
    margin-top: 4rem;
  }
  .el-carousel__item {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    min-height: 35.75rem;
  }

  .el-carousel__indicators {
    display: none;
  }
  // .el-carousel__arrow--left {
  //   display: block !important;
  //   right: 10% !important;
  // }
  // .el-carousel__arrow--right {
  //   display: block !important;
  // }
  .homepagecontentview {
    margin-top: 5rem;
    width: 100%;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 35.75rem;
    min-height: 35.75rem;
  }
  .el-carousel__container {
    height: 100%;
    min-height: 35.75rem;
  }
  .content-carousel {
    width: 100%;
    height: 100%;
    min-height: 35.75rem;
  }
  .el-carousel__item {
    height: 100%;
    min-height: 35.75rem;
  }
  .homepagecontentview-item {
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center 40%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 35.75rem;
    min-height: 35.75rem;

    .homepage-context {
      max-width: 1080px;
      width: 80%;
      height: 35.75rem;
      display: flex;
      flex-direction: column;
      align-content: flex-start;
      justify-content: center;
      padding-left: 2%;
      .homepage-title {
        h1 {
          font-family: "PingFang SC", "Microsoft YaHei" !important;
          font-weight: 900 !important;
          text-transform: uppercase !important;
          font-size: 3rem !important;
          letter-spacing: 2px !important;
          line-height: 1.2em !important;
          // font-size: 4.56rem;
          // font-family: 'PingFang SC','Microsoft YaHei';
          // font-weight: 800;
          color: #ffffff;
          // text-shadow: 0px 2px 3px rgba(4, 0, 0, 0.93);
        }
      }
      .sub-title {
 
        h1 {
          font-family: "PingFang SC", "Microsoft YaHei" !important;
          font-weight: 900 !important;
          text-transform: uppercase !important;
          font-size: 2.4rem !important;
          letter-spacing: 2px !important;
          line-height: 1.2em !important;
          // font-size: 4.56rem;
          // font-family: 'PingFang SC','Microsoft YaHei';
          // font-weight: 800;
          color: #ffffff;
          // text-shadow: 0px 2px 3px rgba(4, 0, 0, 0.93);
        }
      }
      .button {
        width: 8rem;
        height: 4rem;
        background-color: white;
        border-radius: 0.4rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin-top: 1rem;
        padding-top: 1rem;


        p {
          font-family: "PingFang SC", "Microsoft YaHei";
          font-weight: 500;
          color: #000000;
          font-size: 1.4rem;
        }
        &:hover {
          width: 10rem;
          cursor: pointer;
          transition: all 0.2s;
          p {
            // margin-left: -0.5rem;
            transition: all 0.2s;

            .left {
              animation: showInLeft 1s 1;
              display: inline-block;
              font-family: "PingFang SC", "Microsoft YaHei";
              font-weight: 500;
              color: #000000;
              font-size: 1.6rem;
              margin-left: 1rem;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 55rem) {
  .el-carousel__item {
    height: 20.75rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .el-carousel__indicators {
    display: none;
  }

  .homepagecontentview {
    margin-top: 4.8rem;
    width: 100%;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 20.75rem;
  }
  .content-carousel {
    width: 100%;
    height: 20.75rem;
  }
  .el-carousel__item {
    height: 20.75rem;
  }
  .el-carousel__container {
    height: 20.75rem !important;
  }
  .homepagecontentview-item {
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center 40%;
    height: 20.75rem;

    .homepage-context {
      max-width: 1080px;
      width: 80%;
      height: 20.75rem;

      display: flex;
      flex-direction: column;
      align-content: flex-start;
      justify-content: center;
      padding-left: 10%;
      .homepage-title {
        h1 {
          font-family: "PingFang SC", "Microsoft YaHei" !important;
          text-transform: uppercase !important;
          font-size: 1.8rem !important;
          letter-spacing: 2px !important;
          line-height: 1.2em !important;
          color: #ffffff;
        }
      }
      .sub-title {
        margin-top: 1.187rem;
        margin-bottom: 1.187rem;
        h1 {
          font-family: "PingFang SC", "Microsoft YaHei" !important;
          text-transform: uppercase !important;
          font-size: 1.8rem !important;
          letter-spacing: 2px !important;
          line-height: 1.2em !important;
          color: #ffffff;

          // text-shadow: 0px 2px 3px rgba(4, 0, 0, 0.93);
        }
      }
      .button {
        width: 8rem;
        height: 4rem;
        background-color: white;
        border-radius: 0.4rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin-top: 1rem;
        padding-top: 1rem;

        p {
          font-family: "PingFang SC", "Microsoft YaHei";
          font-weight: 500;
          color: #000000;
          font-size: 1.4rem;
        }
        &:hover {
          width: 10rem;
          cursor: pointer;
          transition: all 0.2s;
          p {
            // margin-left: -0.5rem;
            transition: all 0.2s;

            .left {
              animation: showInLeft 1s 1;
              display: inline-block;
              font-family: "PingFang SC", "Microsoft YaHei";
              font-weight: 500;
              color: #000000;
              font-size: 1.6rem;
              margin-left: 1rem;
            }
          }
        }
      }
    }
  }
}
</style>

<template>
  <div class="homepagecontentview">
    <el-carousel :interval="4000" :height="carHeight" class="content-carousel">
      <el-carousel-item v-for="item in imageList" :key="item">
        <div
          class="homepagecontentview-item"
          :style="`background-image:url('${item.url}')`"
        >
          <transition name="fade-in-up">
            <div class="homepage-context">
              <div class="homepage-title">
                <h1>{{ item.title }}</h1>
              </div>
              <div class="sub-title">
                <h1>{{ item.subtitle }}</h1>
              </div>
              <a :href="`${item.href}`"
                ><GetMore class="more-button"></GetMore
              ></a>
            </div>
          </transition>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import GetMore from "@/yintai/view/component/GetMore";

export default {
  name: "homepagecontentview",
  components: { GetMore },

  props: {
    imageList: [String],
  },
  data() {
    return {
      screenWidth: document.body.clientWidth,
      carHeight: "35.75rem",
    };
  },
  mounted() {
    console.log(this.$refs);
    const that = this;
    if (this.screenWidth < 870) {
      this.carHeight = "20.75rem";
    } else {
      this.carHeight = "35.75rem";
    }
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
        // if()
      })();
    };
  },
  methods: {},
};
</script>
